import { createContext, useContext } from 'react';
export const defaultValue = {
    subMenuPopupVisible: false,
    size: 'sm',
};
export const MenuContext = createContext(defaultValue);
export const useMenu = () => useContext(MenuContext);
